import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import queryString from 'query-string';
import { appService } from '../../_services';
import { FaWindows } from 'react-icons/fa';
import { Maintenance } from '../Maintenance/Maintenance.jsx';

let RedirectURL = '', url = '', params = '';

export class UrlPubRedirect extends Component {
    constructor(props) {
        super(props);
        this.state = { IsError: false }
    }

    async renderRedirect() {
        var self = this;
        var code = '';
        var area = '';
        var values = '';
        var pubId = '';

        url = this.props.location.search;
        url = url.replace(/&amp;/g, '&');
        pubId = this.props.pubId;
        params = queryString.parse(url);


        if (pubId != "") {
            await appService.getById('Product/GetPubliucationURL?values=', pubId)
                .then(function (data) {
                    if (data.isErrorExist == true) {
                        const metaRobots = document.createElement('meta');
                        metaRobots.name = 'robots';
                        metaRobots.content = 'noindex';
                        document.head.appendChild(metaRobots);
                        self.setState({ IsError: true });
                    }
                    else {
                        self.RedirectURL = '';
                        if (data.productTypeId == 1) {
                            RedirectURL = "/Journals/" + data.title + "/" + data.prodId;
                        }
                        else if (data.productTypeId == 2) {
                            RedirectURL = "/Manuals/" + data.title + "/" + data.prodId;
                        }
                        else if (data.productTypeId == 3) {
                            RedirectURL = "/Encyclopedias/" + data.title + "/" + data.prodId;

                        }
                    }
                });
        }

        if (RedirectURL != '') {
            window.location.href = RedirectURL;
        }
    }
    render() {
        if (this.state.IsError != true) {
            this.renderRedirect()
        }
        return (
            this.state.IsError != true ?
                <div></div>
                :
                <Maintenance />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Maintenance/UrlPubRedirect.jsx